"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WindowDimensionsContext = require("../../context/WindowDimensionsContext");

var WindowDimensionsProvider = function WindowDimensionsProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)({
    width: window.innerWidth,
    height: window.innerHeight,
    deviceWidth: window.screen.width,
    deviceHeight: window.screen.height
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      if (window.innerWidth !== dimensions.width || window.innerHeight !== dimensions.height || window.screen.width !== dimensions.deviceWidth || window.screen.height !== dimensions.deviceHeight) {
        setDimensions({
          width: window.innerWidth,
          height: window.innerHeight,
          deviceWidth: window.screen.width,
          deviceHeight: window.screen.height
        });
      }
    };

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [dimensions]);
  return _react.default.createElement(_WindowDimensionsContext.WindowDimensionsContext.Provider, {
    value: dimensions
  }, children);
};

WindowDimensionsProvider.propTypes = {
  children: _propTypes.default.node
};
var _default = WindowDimensionsProvider;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/providers/WindowDimensionsProvider.js
// module id = 909
// module chunks = 209 210 211 212